/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".align-wrap[_ngcontent-%COMP%]{align-items:flex-end}.operation-buttons[_ngcontent-%COMP%]   .cell-item[_ngcontent-%COMP%]{text-align:right;position:relative;right:-10px}.address-prop[_ngcontent-%COMP%]{display:flex}\n/*# sourceMappingURL=resolution-asq.component.css.map*/"];
export { styles as styles };
